// Time units data for conversion routes
// Base unit: second

export const timeUnits = [
  { id: 'second', name: 'Second', symbol: 's', plural: 'Seconds', factor: 1 },
  { id: 'millisecond', name: 'Millisecond', symbol: 'ms', plural: 'Milliseconds', factor: 0.001 },
  { id: 'microsecond', name: 'Microsecond', symbol: 'μs', plural: 'Microseconds', factor: 0.000001 },
  { id: 'nanosecond', name: 'Nanosecond', symbol: 'ns', plural: 'Nanoseconds', factor: 0.000000001 },
  { id: 'picosecond', name: 'Picosecond', symbol: 'ps', plural: 'Picoseconds', factor: 0.000000000001 },
  { id: 'minute', name: 'Minute', symbol: 'min', plural: 'Minutes', factor: 60 },
  { id: 'hour', name: 'Hour', symbol: 'h', plural: 'Hours', factor: 3600 },
  { id: 'day', name: 'Day', symbol: 'd', plural: 'Days', factor: 86400 },
  { id: 'week', name: 'Week', symbol: 'wk', plural: 'Weeks', factor: 604800 },
  { id: 'month', name: 'Month', symbol: 'mo', plural: 'Months', factor: 2629746 }, // Average month (365.25/12 days)
  { id: 'year', name: 'Year', symbol: 'yr', plural: 'Years', factor: 31556952 }, // Average year (365.25 days)
  { id: 'decade', name: 'Decade', symbol: 'dec', plural: 'Decades', factor: 315569520 },
  { id: 'century', name: 'Century', symbol: 'c', plural: 'Centuries', factor: 3155695200 },
  { id: 'millennium', name: 'Millennium', symbol: 'ky', plural: 'Millennia', factor: 31556952000 },
];

// Popular conversions matching common usage
export const popularTimeConversions = [
  { from: 'hour', to: 'minute' },
  { from: 'minute', to: 'hour' },
  { from: 'minute', to: 'second' },
  { from: 'second', to: 'minute' },
  { from: 'day', to: 'hour' },
  { from: 'hour', to: 'day' },
  { from: 'week', to: 'day' },
  { from: 'day', to: 'week' },
  { from: 'year', to: 'day' },
  { from: 'day', to: 'year' },
  { from: 'year', to: 'month' },
  { from: 'month', to: 'year' },
  { from: 'hour', to: 'second' },
  { from: 'second', to: 'hour' },
  { from: 'second', to: 'millisecond' },
  { from: 'millisecond', to: 'second' },
  { from: 'year', to: 'week' },
  { from: 'week', to: 'year' },
  { from: 'month', to: 'week' },
  { from: 'week', to: 'month' },
  { from: 'month', to: 'day' },
  { from: 'day', to: 'month' },
  { from: 'century', to: 'year' },
  { from: 'year', to: 'century' },
  { from: 'decade', to: 'year' },
  { from: 'year', to: 'decade' },
  { from: 'millisecond', to: 'microsecond' },
  { from: 'microsecond', to: 'millisecond' },
  { from: 'microsecond', to: 'nanosecond' },
  { from: 'nanosecond', to: 'microsecond' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return timeUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertTime = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to seconds first, then to target unit
  const seconds = value * fromUnit.factor;
  return seconds / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertTime(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online time unit converter.`;
};
